import { NgModule } from '@angular/core';
import { MakePositivePipe } from './make-positive/make-positive';
@NgModule({
	declarations: [MakePositivePipe],
	imports: [],
	exports: [MakePositivePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts